// ============================================================
// GESKANO SITE CONFIG
// Everything Patrick edits regularly lives in this one file.
// ============================================================

export const CONFIG = {
  // ---- SCHEDULE --------------------------------------------
  // Zero-setup fallback only. The backend computes the real next stream
  // itself, all times Eastern (America/New_York): Mon–Fri Lumira 8 PM–5 AM
  // and Callia 5 AM–2 PM; Saturday four hours each (Lumira 8 PM–12 AM,
  // Callia 5–9 AM); Sunday off. Daylight-saving is handled by the calendar.
  // These values show only if the status endpoint can't be reached at all.
  schedule: {
    live: false,
    inWindow: false,
    windowWho: null,
    nextDay: "Saturday",
    nextTime: "8 PM ET",
  },

  // Same story: backend-computed when reachable, this is the fallback line.
  streamWindow: "Mon–Fri · 5 AM–2 PM & 8 PM–5 AM · Sat · 5–9 AM & 8 PM–12 AM ET",

  // ---- ENDPOINTS -------------------------------------------
  // Email: where the notify form POSTs. The backend forwards to
  // your ESP (Buttondown / ConvertKit / Beehiiv / Formspree) when
  // EMAIL_FORWARD_ENDPOINT is set in backend/.env — otherwise it
  // stores the address itself. Swap freely; the list is yours.
  emailEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/subscribe`,

  // Live status: fetched on load. If it fails, the hardcoded
  // schedule above is used silently. Set to null to disable.
  statusEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/status`,

  // Performer registry (Phase 2): powers the notify-form performer pills
  // and the registry-driven pages at /p/<slug>.
  rosterEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/roster`,

  // Launch gate: while now < launchAt, the main page shows a coming-soon
  // screen counting down. The moment it passes, the site opens for everyone.
  comingSoon: true,
  launchAt: "2026-10-16T20:00:00-04:00", // Friday, October 16, 2026 · 8 PM ET (EDT)

  // Access gate: checks the visitor for VPN/proxy/Tor and logs the visit.
  // Fails open — if it can't be reached, everyone gets in.
  gateEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/access-check`,

  // ---- HERO BUTTONS ----------------------------------------
  // Order matters. Twitch stays first and is the primary action.
  // Only these five belong in the hero; everything else is Watch.
  heroPlatforms: ["Twitch", "YouTube", "Kick", "TikTok", "Rumble"],

  // ---- PLATFORMS -------------------------------------------
  // Every link Geskano owns, grouped. To add one: add an entry.
  // To remove one: delete the entry. No dead links, no placeholders.
  platforms: {
    Live: [
      { name: "Twitch", handle: "twitch.tv/geskano", url: "https://twitch.tv/geskano" },
      { name: "YouTube", handle: "youtube.com/@geskano", url: "https://youtube.com/@geskano" },
      { name: "Kick", handle: "kick.com/geskano", url: "https://kick.com/geskano" },
      { name: "Rumble", handle: "rumble.com/c/geskano", url: "https://rumble.com/c/geskano" },
      { name: "TikTok", handle: "tiktok.com/@geskano", url: "https://tiktok.com/@geskano" },
      { name: "Trovo", handle: "trovo.live/s/geskano", url: "https://trovo.live/s/geskano" },
      { name: "Facebook", handle: "facebook.com/geskano", url: "https://facebook.com/geskano" },
    ],
    Social: [
      { name: "X", handle: "x.com/geskano", url: "https://x.com/geskano" },
      { name: "Bluesky", handle: "bsky.app/profile/geskano.com", url: "https://bsky.app/profile/geskano.com" },
      { name: "Instagram", handle: "instagram.com/gesskahno", url: "https://instagram.com/gesskahno" },
      { name: "Pinterest", handle: "pinterest.com/geskano", url: "https://pinterest.com/geskano" },
    ],
    Community: [
      { name: "Reddit", handle: "reddit.com/r/geskano", url: "https://reddit.com/r/geskano" },
      { name: "Locals", handle: "geskano.locals.com", url: "https://geskano.locals.com" },
      { name: "Steam", handle: "steamcommunity.com/id/geskano", url: "https://steamcommunity.com/id/geskano" },
    ],
    Gaming: [
      { name: "Xbox", handle: "Geskano8428", url: "https://www.xbox.com/play/user/Geskano8428" },
      { name: "PlayStation", handle: "PSN · Geskano", url: "https://psnprofiles.com/Geskano" },
    ],
    // Not rendered — no public profile URL exists to link to:
    //   Discord (needs a discord.gg invite link), Riot Games, Nintendo,
    //   Epic Games, Battle.net (no public profile pages),
    //   BIGO Live (handle not claimed).
  },
};
